import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import { api } from "../../../services/api/api.service";
import { API_LEAGUE_TABLE } from "../../../services/api/api.urls";
import {toastr} from "react-redux-toastr";
import { ILeagueTable, ILeagueTableItem } from "./types";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";

const initialState: ILeagueTable = {
    items: [] as ILeagueTableItem[]
}

export const getLeagueTableData = createAsyncThunk<ILeagueTable, { id: number, group: number }, { rejectValue: string }>(
    'leagueTable/get',
    async ({id,group}, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_LEAGUE_TABLE}/${id}/${group}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Failed to fetch League table data.");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const leagueTableSlice = createSlice({
    name: 'preMatch',
    reducers: {
        setLeagueTable: (state, action: PayloadAction<ILeagueTable>) => {

            const {items} = action.payload;
            state.items = items;
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getLeagueTableData.fulfilled, (state, action) => {
                const {items} = action.payload;
                state.items = items
            })
    }
})

export const {
    setLeagueTable,
} = leagueTableSlice.actions;
export default leagueTableSlice.reducer;
